import React, { useState, useEffect } from 'react'
import Classes from './Subscriptions.module.css'
import useScreenWidth from '../../../../../Hooks/useScreenWidth';
import SkeletonLoading from '../../../../GlobalComponents/SkeletonLoading/SkeletonLoading';
import { useSelector } from 'react-redux';
import { Pagination, Stack } from '@mui/material';
import TableRow from './TableRow';
import { useNavigate } from 'react-router-dom';

const AddIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" {...props} viewBox="0 0 448 512"><path d="M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z" /></svg>
)

export default function Subscriptions() {
    const initialsubscriptions = [
        { id: 1, name: "John Smith", service: "Website Audit", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 2, name: "Joe Smith", service: "SEO", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Canceled" },
        { id: 3, name: "Brandon Smith", service: "UI/UX", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 4, name: "Jeff Smith", service: "Website Audit", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 5, name: "Nick Smith", service: "SEO", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 6, name: "Jake Smith", service: "Copywriting", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 7, name: "Lenny Smith", service: "UI/UX", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
        { id: 8, name: "Lenny Smith", service: "UI/UX", payments: 1, lastPayment: "March 1, 2025", amount: "$125.00", status: "Active" },
    ];

    const [loading, setLoading] = useState(true);
    const navigateTo = useNavigate();
    const screenWidth = useScreenWidth();
    const isMobile = screenWidth <= 480;

    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 8;

    const totalPages = Math.ceil(initialsubscriptions.length / itemsPerPage);
    const currentItems = initialsubscriptions.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );
    const startItem = (currentPage - 1) * itemsPerPage + 1;
    const endItem = Math.min(currentPage * itemsPerPage, initialsubscriptions.length);
    const totalItems = initialsubscriptions.length;

    function handlePageChange(e, pageNum) {
        setCurrentPage(pageNum);
    }

    const handleAddOrder = () => {
        navigateTo('/add-subscription');
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className={Classes.hero}>
            <div className={Classes.header}>
                <div>
                    <h3>Subscriptions</h3>
                    <h5>Create and edit subscriptions for your clients.</h5>
                </div>
                <div>
                    <div className={Classes.searcCon}>
                        <img src="/assets/images/search.png" alt="icon" />
                        <input type="text" placeholder="Search..." />
                    </div>
                </div>
            </div>

            <div className={Classes.table} >
                <div className={Classes.tableWrapper}>
                    <div className={Classes.tableBanner} >
                        <div className='flexAlign10' >
                            <div className={Classes.tableBannerItem}>
                                <h5>Canceled</h5>
                                <h4>3</h4>
                            </div>
                            <div className={Classes.tableBannerItem}>
                                <h5>Active</h5>
                                <h4>0</h4>
                            </div>
                            <h5 className={Classes.allText} >All</h5>
                        </div>
                        <div>
                            <button onClick={handleAddOrder} className={Classes.addBtn}>
                                <AddIcon height='12px' fill='white' />
                                <h5>Add subscription</h5>
                            </button>
                        </div>
                    </div>

                    <div className={Classes.tableHeader}>
                        <div className={`${Classes.headerItem} ${Classes.header1}`}>
                            <input type='checkbox' />
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header2}`}>
                            <h5>Name</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header3}`}>
                            <h5>Service</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header4}`}>
                            <h5>Payments</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header5}`}>
                            <h5>Last Payment</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header6}`}>
                            <h5>Amount</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header7}`} >
                            <h5>Status</h5>
                        </div>
                        <div className={`${Classes.headerItem} ${Classes.header8}`} />
                    </div>

                    <div className={Classes.tableBody}>
                        {loading ? (
                            <SkeletonLoading
                                length={itemsPerPage}
                                height={isMobile ? '6rem' : '2.8rem'}
                                width="100%"
                                br="6px"
                            />
                        ) : currentItems && currentItems.length > 0 ? (
                            currentItems.map((cust, idx) => (
                                <TableRow
                                    key={cust._id}
                                    value={cust}
                                    index={idx}
                                />
                            ))
                        ) : (
                            <div>No subscription found.</div>
                        )}
                    </div>

                    <div className={Classes.pagFooter}>
                        <h5 style={{ height: '1.2rem' }}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='10rem' br='4px' padding='0' />
                                : `Showing ${startItem} to ${endItem} of ${totalItems} results`
                            }
                        </h5>
                        <Stack spacing={2} className={Classes.pagination}>
                            {loading
                                ? <SkeletonLoading height='1.2rem' width='5rem' br='4px' padding='0' />
                                : <Pagination
                                    count={totalPages}
                                    page={currentPage}
                                    onChange={handlePageChange}
                                    shape="rounded"
                                />
                            }
                        </Stack>
                    </div>
                </div>
            </div>
        </div>
    )
}
